module.exports = __webpack_public_path__ + "static/img/pickering2.d59c547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/pickering2.jpg
// module id = 121
// module chunks = 9